import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgReduxModule, NgRedux } from '@angular-redux/store';
import { IAppState } from './store/IAppState';
import { store } from './store/mc-store';
import { StateService } from './state.service';
import { SessionAction } from './modules/session/session.action';
import { ProgressAction } from './modules/progress/progress.action';


@NgModule({
  imports: [
    CommonModule,
    NgReduxModule
  ],
  declarations: [],
  providers: [StateService, SessionAction, ProgressAction]
})
export class AppStatesModule {
  constructor(ngRedux: NgRedux<IAppState>) {
    ngRedux.provideStore(store);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/app-states.module.ts